import type React from 'react';
import AppEnvironment from '../environment/app-environment';

export const reportAccessibility = async (App: typeof React, config?: Record<string, unknown>): Promise<void> => {
  // Start Axe Testing on lower environments and local
  if (AppEnvironment.env !== 'prod' && AppEnvironment.env !== 'fed-prod') {
    // dynamic imports so that they only get added on non-prod builds/runs
    const axe = await import('@axe-core/react');

    // most likely this line is going to change after axe-core release proper support for React 18
    const ReactDOM = await import('react-dom');
    await axe.default(App, ReactDOM, 1000, config);
  }
};
